import { j as r } from "../jsx-runtime-Wav_3Wde.js";
import { ThemeProvider as u } from "styled-components";
import "../index.esm-DOxVcNnO.js";
import "styled-system";
import "../Icon/StyledPath.mjs";
import f from "../Icon/Icons/LockIcon.mjs";
import n from "../typography/VisuallyHidden/VisuallyHidden.mjs";
import { BackgroundOverlay as C, ContentWrapper as g, CircleWrapper as k, blankTheme as T, Circle as W } from "./components.mjs";
const H = ({ active: l = !0, bgOverlay: c = "solid", color: d, circleSize: m, circleThickness: a, heading: o = null, Icon: i = f, theme: s = T, position: p, children: x, ...j }) => {
  const e = () => /* @__PURE__ */ r.jsx(W, {
    borderWidth: a
  }), t = /* @__PURE__ */ r.jsx(C, {
    active: l,
    bgOverlay: c,
    position: p,
    ...j,
    children: /* @__PURE__ */ r.jsxs(g, {
      children: [
        /* @__PURE__ */ r.jsxs(k, {
          "data-qa-id": "loading-spinner-circle",
          color: d,
          size: m,
          children: [
            /* @__PURE__ */ r.jsx(e, {}),
            /* @__PURE__ */ r.jsx(e, {}),
            /* @__PURE__ */ r.jsx(e, {}),
            /* @__PURE__ */ r.jsx(e, {}),
            i && /* @__PURE__ */ r.jsx(i, {
              color: "currentColor",
              size: "50%",
              m: "auto"
            })
          ]
        }),
        o && /* @__PURE__ */ r.jsx(n, {
          as: "h1",
          children: o
        }),
        x || /* @__PURE__ */ r.jsx(n, {
          children: "Content is loading"
        })
      ]
    })
  });
  if (s) {
    const h = s;
    return /* @__PURE__ */ r.jsx(u, {
      theme: h,
      children: t
    });
  }
  return t;
};
export {
  H as default
};
